<template>
  <div class="invoice-container" v-if="!state.loading">
    <h2>Edit Invoice</h2>

    <div class="form-grid">
      <div class="form-group" style="width: 100%;flex-basis: 100%;">
        <label>Invoice</label>
        <select v-model="form.type">
          <option value="Sales">
            Sales Invoice
          </option>
          <option value="Purchase">
            Purchase Invoice
          </option>
        </select>
      </div>
      <div v-if="form.type == 'Sales'" class="form-group" style="width: 100%;flex-basis: 100%;">
        <label>Customer</label>
        <select v-model="form.recipient">
          <option v-for="(o, i) in customers" :key="i" :value="o.value">
            {{ o.label }}
          </option>
        </select>
      </div>
      <div v-else class="form-group" style="width: 100%;flex-basis: 100%;">
        <label>Vendor</label>
        <select v-model="form.recipient">
          <option v-for="(o, i) in vendors" :key="i" :value="o.value">
            {{ o.label }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Date Issued</label>
        <CalendarView
          class="input"
          v-model="form.dateIssued"
        />
      </div>
      <div class="form-group">
        <label>Due Date</label>
        <CalendarView
          class="input"
          v-model="form.dueDate"
        />
      </div>
    </div>

    <h3>Invoice Items</h3>
    <table>
      <thead>
        <tr>
          <th>Description</th>
          <th>Qty</th>
          <th>Unit Price</th>
          <th>Total</th>
          <th></th>
        </tr>
      </thead>
        <tbody>
            <tr v-for="(item, index) in form.items" :key="index">
                <td data-label="Description"><input v-model="item.description" /></td>
                <td data-label="Qty"><input type="text" v-model.number="item.quantity" /></td>
                <td data-label="Unit Price"><input type="number" v-model.number="item.unitPrice" /></td>
                <td data-label="Total">₦{{ item.quantity * item.unitPrice }}</td>
                <td><button @click="removeItem(index)">Remove</button></td>
            </tr>
        </tbody>

    </table>

    <button @click="addItem" class="add-btn">+ Add Item</button>

    <div class="totals">
      <div>
        <label>Tax (%)</label>
        <input v-model.number="form.taxRate" type="number" />
      </div>
      <div>
        <label>Discount (₦)</label>
        <input v-model.number="form.discount" type="number" />
      </div>
    </div>

    <div class="summary">
      <p><strong>Subtotal:</strong> ₦{{ subtotal }}</p>
      <p><strong>Tax:</strong> ₦{{ tax }}</p>
      <p><strong>Discount:</strong> ₦{{ form.discount }}</p>
      <p><strong>Total:</strong> ₦{{ total }}</p>
    </div>

    <button @click="submitInvoice" class="submit-btn" v-if="!state.submitting">Submit Invoice</button>
    <div class="temp-row" v-else style="text-align: center;">
      <img src="@/assets/img/ajldr.gif" style="width:100px"/>
    </div>
  </div>
  <div class="temp-row" v-else style="text-align: center;">
    <img src="@/assets/img/ajldr.gif" style="width:100px"/>
  </div>
</template>

<script>
import { ref, computed, reactive, onMounted } from 'vue'
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import {  useRoute, useRouter } from 'vue-router';
import CalendarView from "@/components/CalendarView.vue";

export default{
  name:"CreateInvoice",
  components:{CalendarView},
  setup(){
    const route = useRoute();
    const router = useRouter();
    const state=reactive({loading:true})
    const invoice_id = computed(() => route.params.id).value
    const customers=ref([]);
    const vendors=ref([]);
    const form = ref({
      type: '',
      dateIssued: '',
      dueDate: '',
      recipient: '',
      taxRate: 0,
      discount: 0,
      id:"",
      items: [],
      updateInvoice:"",
      deleteItems:[]
    })

    const addItem = () => {
      form.value.items.push({ description: '', quantity: 1, unitPrice: 0, id:"new" })
    }

    const removeItem = (index) => {
      form.value.deleteItems.push(form.value.items[index].id)
      form.value.items.splice(index, 1)
    }

    const subtotal = computed(() => {
      return form.value.items.reduce((sum, item) => {
        return sum + (item.quantity * item.unitPrice)
      }, 0)
    })

    const tax = computed(() => {
      return (subtotal.value * form.value.taxRate) / 100
    })

    const total = computed(() => {
      return subtotal.value + tax.value - form.value.discount
    })

    const submitInvoice = () => {
      console.log(form.value);
      state.submitting=true
      call({
          url:urls.transactions,
          data:form.value,
          success:(res)=>{
            state.submitting=false
            if(res.status){
              var d=res.msg;
              router.push({ name: 'viewinvoice', params: { id: d } });
            }else{
              alert(res.msg);
            }
          }
        })
    }

    onMounted(() => {
        call({
          url:urls.transactions,
          data:{startEditInvoice:invoice_id},
          success:(res)=>{
              state.loading=false
              if(res.status){
                  var d=res.msg;
                  customers.value=[];
                  Object.keys(d.customers).forEach(k => {
                      customers.value.push(d.customers[k])
                  })
                  vendors.value=[];
                  Object.keys(d.vendors).forEach(k => {
                      vendors.value.push(d.vendors[k])
                  })
                  var i=d.invoice;
                  form.value.type=i.type;
                  form.value.recipient=i.cus;
                  form.value.dateIssued=i.date;
                  form.value.dueDate=i.due;
                  form.value.taxRate=i.tax;
                  form.value.discount=i.discount;
                  form.value.id=i.id;
                  Object.keys(d.items).forEach(k => {
                    form.value.items.push(d.items[k])
                  })
              }else{
                  alert(res.msg);
              }
          }
        })
    });

    return{
      form,addItem,removeItem,subtotal,tax,total,submitInvoice,vendors,
      state,customers
    }
  }
}
</script>

<style scoped>
.invoice-container {
    max-width: 800px;
    margin: 20px auto;
    padding: 1rem;
    border-radius: 17px;
    background: var(--white-color);
}

h2, h3 {
  margin-bottom: 10px;
}

.form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 20px;
}

.form-group {
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
}
p{
  margin-top: 0;
    margin-bottom: 1rem;
    color: var(--black);
}

.form-group label {
    margin-bottom: 5px;
    font-weight: bold;
    color: var(--black);
}

input {
    padding: 15px;
    border: 0;
    border-radius: 3px;
    background: var(--input-bg);
    color: var(--light-text-color);
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
  font-size: 0.95rem;
}

th, td {
  padding: 8px;
  text-align: left;
    color: var(--black);
    padding-bottom: 0;
}

button {
    background: var(--primary-color);
    color: var(--white-color);
    box-shadow: none;
    border: 0;
    padding: 10px 20px 10px 20px;
    font-size: 15px;
    text-align: center;
    border-radius: 5px;    
    color: var(--black);
    text-shadow: none;
}

button:hover {
  background-color: #0369a1;
}

.add-btn, .submit-btn {
  margin-top: 10px;
}

label{
  color: var(--black);
  display: block;
  margin-top: 15px;
}

.totals {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 10px 0;
}

.totals > div {
  flex: 1 1 200px;
  display: flex;
  flex-direction: column;
}

.summary {
  margin-top: 25px;
  font-size: 1rem;
  font-weight: 500;
}

/* Mobile Responsiveness */
@media (max-width: 600px) {
  .form-grid {
    flex-direction: column;
  }

  table, thead, tbody, th, td, tr {
    display: block;
  }

  thead {
    display: none;
  }

  tbody tr {
    margin-bottom: 1rem;        
    border-bottom: 1px solid var(--data-table-border);
    padding: 0.5rem;
    border-radius: 4px;
  }

  tbody td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
  }

  tbody td::before {
    content: attr(data-label);
    font-weight: bold;
    margin-right: 10px;
    flex-shrink: 0;
  }
}

</style>
